import type { RouterConfig } from '@nuxt/schema'
import { unifiedRoutes, type GeneratedRoute } from '../../generated/routes'
import { RoutingDefinitions } from '../generator/types/RoutingDefinitions'
import { IRouteMeta } from "@app/interfaces/dtos/IRouteMeta";

// Separate organization routes from other routes
const organizationRoutes: GeneratedRoute[] = []
const otherRoutes: GeneratedRoute[] = []

unifiedRoutes.forEach((route) => {
	if (route.name?.includes('Organisation')) {
		organizationRoutes.push(route)
	} else {
		otherRoutes.push(route)
	}
})

// Reorder: other routes first, organization routes last (lower priority)
const orderedRoutes = [...otherRoutes, ...organizationRoutes]

const computedRoutes: {
	name: string
	path: string
	meta: IRouteMeta
	component: () => Promise<any>
}[] = []

orderedRoutes.forEach((route) => {
	// Use specific component for catch-all route, otherwise use _gen.vue
	const component = route.name as RoutingDefinitions === RoutingDefinitions.CATCH_ALL
		? (): Promise<any> => import('./pages/[...catchall].vue')
		: (): Promise<any> => import('./pages/_gen.vue');

	computedRoutes.push({
		name: route.name,
		path: route.path,
		meta: route.meta,
		component,
	})
})

export default {
	routes: (scanned) => {
		const catchAllRoute = scanned.find(route => route.path === '/:catchall(.*)*')
		const normalizedScanned = scanned.filter(route => route.path !== '/:catchall(.*)*')

		return [
			...normalizedScanned,
			...computedRoutes,
			...(catchAllRoute ? [{ ...catchAllRoute, name: RoutingDefinitions.CATCH_ALL }] : [])
		]
	},

	scrollBehavior: (to, from, saved) => saved ?? { top: 0 }
} as RouterConfig
